import { QueryParameterSchema } from '../../context/QueryParameterContext';

export const countryFilter: QueryParameterSchema<'country'> = {
  getDefaultValue: () => [],
  getValue: ({ parameters }) => parameters.country,

  fromUrlSearchParams: ({ urlSearchParams }) => ({
    country: (urlSearchParams.get('filter[country]') || '').split(',').filter((s) => !!s),
  }),
  toUrlSearchParams: ({ value }) => {
    if (value.length === 0) return null;
    return { 'filter[country]': value.join(',') };
  },
  toSearchQuery: ({ value }) => {
    if (value.length === 0) return null;
    return { 'filter[country]': value };
  },
  sanitize: ({ value, staticProps }) => {
    const {
      referenceData: { countries },
    } = staticProps;
    return { country: value.filter((s) => !!s && !!countries[s]) };
  },
  getSummaryItems: ({
    value,
    staticProps: {
      referenceData: { countries },
    },
  }) => {
    return value.map((countryCode) => ({
      filterKey: 'country',
      key: `country_${countryCode}`,
      label: countries[countryCode]!.countryLabel,
      value: countryCode,
    }));
  },
  removeParam: ({ value, removedValue }) => {
    return { country: value.filter((item) => item !== removedValue) };
  },
};
